/*eslint-disable*/
import {
	Card,
	FormControl,
	CircularProgress,
	Typography
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import sqLogo from 'assets/img/sure_quote_website_logo.png';
import background from 'assets/img/web-background2.jpg';
import Snackbar from 'components/Snackbar/Snackbar.jsx';
import FormInput from 'components/Wrappers/materialUIWrappers/components/FormInput';
import FormInputPassword from 'components/Wrappers/materialUIWrappers/components/FormInputPassword';
import gql from 'graphql-tag';
import React from 'react';
import { graphql } from 'react-apollo';
import { Click } from 'reducers/LoginReducer';
import { Field, reduxForm } from 'redux-form';
import store from '../../store';
import './login.css';
import { Logout } from 'helpers/UserHelper.js';
import { showSnack } from 'reducers/NotificationReducer';
//import { ParseUriParams } from "helpers/UriReader";

const required = value => (value ? undefined : 'Required');

const CLICK = 'sure-quote/Login/CLICK';

const loginM = gql`
	mutation login($input: LoginMInput!) {
		LoginM(input: $input) {
			id
			token
			name
			surname
			avatar
			userType
			accountStatus
			error
		}
	}
`;

class Login extends React.Component {
	state = {
		checkValidation: false,
		loading: false
	};

	componentDidMount() {
		Logout();
	}

	handleClick = () => {
		if (store.getState().form.login.syncErrors) {
			store.dispatch(
				showSnack({
					message: 'Invalid data.',
					color: 'danger'
				})
			);
			this.setState({ checkValidation: true });
			this.forceUpdate();
		} else {
			this.setState({ checkValidation: false, loading: true });

			var input = {
				userEmail: store.getState().form.login.values.username,
				userPassword: store.getState().form.login.values.password
			};

			this.props
				.mutate({
					variables: {
						input
					}
				})
				.then(response => {
					var obj = response.data.LoginM;

					if (obj.error) {
						store.dispatch(
							showSnack({
								message: obj.error,
								color: 'danger'
							})
						);
						this.setState({ loading: false });
						return;
					}

					obj.userName = store.getState().form.login.values.username;
					store.dispatch(Click({ type: CLICK, props: response.data.LoginM }));

					let keys = Object.keys(response.data.LoginM).filter(
						k => k !== '__typename'
					);
					keys.map(k => {
						if (response.data.LoginM[k] && response.data.LoginM[k] !== null) {
							localStorage.setItem(k, response.data.LoginM[k].toString());
						}
					});

					this.setState({ loading: false });

					if (response.data.LoginM.token != '') {
						switch (response.data.LoginM.userType) {
							case '1':
								this.props.history.push('/app/brokerageAdminProfile');
								break;
							case '2' || '3':
								this.props.history.push('/app/home');
								break;
							case '3':
								this.props.history.push('/app/home');
								break;
							case '6':
								this.props.history.push('/app/home');
								break;
							default:
								break;
						}
					}
				})
				.catch(error => {
					this.setState({ loading: false });
					var err = error.toString().split('Error: GraphQL error: ')[1];
					store.dispatch(
						showSnack({
							message: err,
							color: 'danger'
						})
					);
				});
		}
	};

	passwordKeyPressed = e => {
		if (e.key === 'Enter') {
			this.handleClick();
		}
		return;
	};

	render() {
		const validate = [];
		validate.push(required);
		return (
			<div
				className={'loginContainer'}
				style={{ backgroundImage: 'url(' + background + ')' }}
			>
				<Card className={'loginCard'}>
					<div className={'loginBox'}>
						<div className={'sqLogoContainer'}>
							<img className="sqLogo" src={sqLogo} alt="sqLogo" />
						</div>

						<FormControl fullWidth>
							<Field
								component={FormInput}
								isrequired={true}
								validate={[...validate]}
								checkValidation={this.state.checkValidation}
								name="username"
								label="Username"
							/>
						</FormControl>

						<br />

						<FormControl fullWidth>
							<Field
								component={FormInputPassword}
								isrequired={true}
								validate={[...validate]}
								checkValidation={this.state.checkValidation}
								name="password"
								label="Password"
								handleKeyPress={this.passwordKeyPressed}
							/>
						</FormControl>

						<Button
							variant="outlined"
							className="outlinedButton"
							color="primary"
							style={{ margin: 'auto', marginTop: '8vh', marginBottom: '15px' }}
							color="primary"
							fullWidth
							onClick={!this.state.loading ? this.handleClick : {}}
						>
							{this.state.loading ? <CircularProgress size={20} /> : 'Sign In'}
						</Button>

						<Typography
							variant="body1"
							style={{
								color: '#0000008a',
								marginBottom: '15vh'
							}}
							className="typographyLinkBasic"
							onClick={() => {
								this.props.history.push('/app/portal/forgotpassword');
							}}
						>
							Forgot Password?
						</Typography>
					</div>
				</Card>
			</div>
		);
	}
}

Login = graphql(loginM)(Login);

Login = reduxForm({
	form: 'login',
	destroyOnUnmount: true
})(Login);

export default Login;



// WEBPACK FOOTER //
// ./src/views/Login/Login.jsx